import { GetMFAMethodsResponse } from '@api/requests/mfa/getMFAMethods';

import MFA_METHODS_ENUM from '../enums/MFA_METHODS.enum';

export const mapAvailableMFAMethods = (mfaMethods?: GetMFAMethodsResponse) => {
	if (mfaMethods) {
		const defaultMethods = Object.values(MFA_METHODS_ENUM);
		return mfaMethods?.options.reduce<MFA_METHODS_ENUM[]>((acc, option) => {
			const method = defaultMethods.find(mfaMethod => option.includes(mfaMethod));
			if (method) return [...acc, method];
			else return acc;
		}, []);
	}
};
